import React, { createRef } from "react";
import PropTypes from 'prop-types';
import Label from "../../Buttons/Label";
import NoCvButton from "../../Buttons/NoCvButton";
import renderLoader from "../../base/Loader";

export default class CreateOrUploadCVStep extends React.PureComponent
{
    static propTypes = {
        language: PropTypes.string.isRequired,
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nextStep: PropTypes.func.isRequired,
        changeCandidateData: PropTypes.func.isRequired,
        customerName: PropTypes.string.isRequired,
        showModal: PropTypes.func.isRequired,
        requireCv: PropTypes.bool.isRequired,
        agency: PropTypes.string,
        setBannerData: PropTypes.func,
		uploadToMongo: PropTypes.func
    };

    static defaultProps = {
        positionId: null,
        agency: ''
    };

	acceptTypes = '.pdf,.doc,.docx,.odt,.rtf,application/pdf,application/msword,image/jpeg,application/json,text/plain,image/png,application/rtf,application/vnd.oasis.opendocument.text,message/rfc822,application/octet-stream,text/html';

    maxSizeMb = 10;
    maxSize = this.maxSizeMb * 1024 * 1024;

    constructor(props) {
        super(props);
        this.state = {loading: false};

        this.fileInputRef = createRef();
    }


    render() {
        if (this.state['loading']) {
            return (<div className={"mx-auto"}>{renderLoader('d-block text-center display-3')} </div>);
        }
        return (
            <>
                <div className={ "col-12 height-30 border-radius-1 " + (this.props.requireCv ? '': 'col-md-6')}  >
                    <input
	                    ref={this.fileInputRef}
                        type="file"
                        id="cv_file"
                        name="cv_file"
                        accept={null}
                        className={'inputfile col-12'}
                        onChange={(e) =>  this.props.uploadToMongo(e.target.files[0])}
                    />
                    <Label customerName={this.props.customerName} className={'col-12 height-60'} htmlFor={"cv_file"} positionId={this.props.positionId}>
                        <i className={'fa fa-fw fa-file-upload margin-right-10  padding-top-20 padding-bottom-20 padding-left-0-75rem'}> </i>
                        {window.Translator.getSlug('AttachYoursCv',this.props.language)} &nbsp;
                    </Label>
                </div>
                {!this.props.requireCv &&
                <NoCvButton language = {this.props.language} positionId = {this.props.positionId} customerName = {this.props.customerName} onClick = {this.props.nextStep} />
                }
            </>
        );
    }
}
